import { render, staticRenderFns } from "./SocialBox.vue?vue&type=template&id=215dcab2&scoped=true&"
import script from "./SocialBox.vue?vue&type=script&lang=js&"
export * from "./SocialBox.vue?vue&type=script&lang=js&"
import style0 from "./SocialBox.vue?vue&type=style&index=0&id=215dcab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215dcab2",
  null
  
)

export default component.exports